"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApproveOrderMessage = void 0;
const similarProducts_1 = require("../../../services/similarProducts");
const parseToBRL_1 = require("../../../utils/helpers/parseToBRL");
const builders_1 = require("../builders");
const helpers_1 = require("../helpers");
const getApproveOrderMessage = ({ orderBackofficeId, reseller, cartItems, totalPrice, businessUnit, similarItems: similarProducts, }) => {
    let message = `Oi, ${reseller.catalogName}!\n\n`;
    message += `Acessei à sua loja digital e escolhi:\n\n`;
    message += buildProductListMessage(cartItems, similarProducts);
    message += `Valor total: *${totalPrice}*\n\n`;
    message +=
        '🛍️ *Quando posso buscar ou receber a minha compra?* Vamos combinar como você vai me entregar!\n\n ';
    message += '💚 Mensagem do Boticário:\n';
    message += `${reseller.catalogName}, para *ver os produtos e gerar o link de pagamento,* acesse o aplicativo: ${(0, builders_1.buildApproveOrderRedirectPageLink)(orderBackofficeId, reseller.catalogSlug, businessUnit)}`;
    return message;
};
exports.getApproveOrderMessage = getApproveOrderMessage;
const buildSimilarProductSuggestionMessage = (similarProduct, cartItemQuantity) => {
    if (!similarProduct)
        return '';
    if (similarProducts_1.SelectedSimilarProductService.isLetResellerRecommends(similarProduct))
        return ' - Se esse produto acabar, você pode sugerir outro produto para substituir.';
    const price = (0, parseToBRL_1.parseToBRL)(Number(similarProduct.discountPrice));
    return ` - Se esse produto acabar, substituir por:\n*${(0, helpers_1.formatQuantityLabel)(cartItemQuantity)} ${similarProduct.name}* | Código ${similarProduct.sku} | ${price}/cada`;
};
const buildProductListMessage = (cartItems, similarProducts) => {
    return cartItems.reduce((acc, cur) => {
        const { id, name, discountPrice, quantity } = cur;
        const productQuantity = (0, helpers_1.formatQuantityLabel)(quantity);
        const price = (0, parseToBRL_1.parseToBRL)(parseFloat(discountPrice));
        let similarProductMessage = '';
        if (similarProducts) {
            const similarProduct = similarProducts[id];
            similarProductMessage = buildSimilarProductSuggestionMessage(similarProduct, quantity);
        }
        const line = `*${productQuantity} ${name}*\nCódigo: ${id} | ${price}/cada${similarProductMessage}\n\n`;
        return `${acc}${line}`;
    }, '');
};
